<template>
	<div class="indexBody">
		<div style="width:71%; margin: 0 14.5%; ">
			<div style="width: 100%; text-align: center; color: #fff; font-size: 4.5rem;letter-spacing: 8px; height: 150px; padding-top: 50px;">集成电路会展网</div>
			<div style="width:76%; padding:0 12%; height: auto;" >
				<div style="cursor: pointer; float: left; width: 33.3%;text-align: center; " class="layer" @click="open('http://iccad.xmtexpo.com')">
					<img style="pointer-events: none; width:88%; height:auto" :src="config.iccad" >
				</div>
				<div style="cursor: pointer; float: left; text-align: center; width: 33.3%;" class="layer"  @click="open('http://icdia.xmtexpo.com')">
				<!-- <div style="cursor: pointer; float: left; text-align: center; width: 33.3%;" class="layer"> -->
					<img style="pointer-events: none; width:88%; height:auto" :src="config.icdia" >
				</div>
				<!-- <div style="cursor: pointer; float: left; width: 33.3%;text-align: center; " class="layer" > -->
				<div style="cursor: pointer; float: left; width: 33.3%;text-align: center; " class="layer"  @click="open('http://aeif.xmtexpo.com')">
					<img style="pointer-events: none; width:88%; height:auto" :src="config.aeif" >
				</div>
			</div>
			<div style="clear: both;"></div>
			<div style=" width: 100%; height: 50px; border-bottom: 0.5px solid #fff;"></div>
		</div>
		<div style="clear: both;"></div>
		<div style=" background-color: rgba(62, 62, 159, 0.5); height: 70px; width: 100%;letter-spacing: 0.5px;  font-size: 14px; margin-top: 70px; text-align: center; color: #fff; padding:20px 0; line-height: 1.75;">
			<div style="font-size: 1rem; ">芯脉通会展策划（上海）有限公司&nbsp;&nbsp;&nbsp;&nbsp;YAXUN INTERNATIONAL CO., LIMITED&nbsp;&nbsp;&nbsp;&nbsp;地址：上海市徐汇区中山西路2025号永升大厦1505-1506室（200235）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 电话: +86.21.54565366</div>
			<div style="font-size: 1rem; ">沪ICP备 2023008635号-1</div>
		</div>
	</div>
</template>
<script>
	import request from '@/api/axios'
	
	import { Search } from '@element-plus/icons-vue'


	export default{
		name:'indexComponent',
		data() {
			return{
				style: '',
				bg: '',
				height:'',
				config: {}
			}
		},
		mounted(){
			this.getData()
		},
		methods: {
			open(url) {
				window.location.href= url
			},
			getData() {
				const that = this
				request({url: '/index/list', method: 'get'}).then(res => {
					if (res.code == 0) {
						that.config = res.data.list[0]
						that.config.iccad = 'http://xmthz.cn/' + that.config.iccad
						that.config.iccadSelected = 'http://xmthz.cn/' + that.config.iccadSelected
						that.config.icdia = 'http://xmthz.cn/' + that.config.icdia
						that.config.icdiaSelected = 'http://xmthz.cn/' + that.config.icdiaSelected
						that.config.aeif = 'http://xmthz.cn/' + that.config.aeif
						that.config.aeifSelected = 'http://xmthz.cn/' + that.config.aeifSelected
					}
				});
			},
		}
	}
	
</script>

<style>
.indexBody {
	 position:fixed;
	  top: 0;
	  left: 0;
	width: 100%; 
	height: 100%; 
	background-image: url('../assets/images/bg.png'); 
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.layer:hover{
animation: mapJump 2s infinite;
-webkit-animation: mapJump 2s infinite;
}
@keyframes imgTopAnimation{
		0%{ margin-top: -300px;}
		100%{ margin-top:110px;}
	}
	@-webkit-keyframes imgTopAnimation{
		0%{ margin-top: -300px;}
		100%{ margin-top:110px;}
	}
	@-moz-keyframes imgTopAnimation{
		0%{ margin-top: -300px;}
		100%{ margin-top:110px;}
	}
	@keyframes imgRightAnimation{
		0%{ margin-top: 600px;}
		100%{ margin-top:275px;}
	}
	@-webkit-keyframes imgRightAnimation{
		0%{ margin-top: 600px;}
		100%{ margin-top:275px;}
	}
	@-moz-keyframes imgRightAnimation{
		0%{ margin-top: 600px;}
		100%{ margin-top:275px;}
	}
	@keyframes mapJump {
		0% {transform:translateY(0);}
		20% {transform:translateY(0);}
		40% {transform:translateY(-20px);}
		50% {transform:translateY(0);}
		60% {transform:translateY(-10px);}
		80% {transform:translateY(0);}
		100% {transform:translateY(0);}
	}
	@-webkit-keyframes mapJump {
		0% {-webkit-transform:translateY(0);}
		20% {-webkit-transform:translateY(0);}
		40% {-webkit-transform:translateY(-20px);}
		50% {-webkit-transform:translateY(0);}
		60% {-webkit-transform:translateY(-10px);}
		80% {-webkit-transform:translateY(0);}
		100% {-webkit-transform:translateY(0);}
	}
</style>